import { LoadingMessage, LocaleDictionaryType } from "@/lib/main";
import { CSSProperties } from "react";

type Props = { message: LocaleDictionaryType };

export default function FillContainerLoadingMessage({ message }: Props) {
  const styles: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    height: "100%",
    width: "100%",
  };

  return (
    <div style={styles}>
      <LoadingMessage message={message} />
    </div>
  );
}
